import validate from "/srv/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import airbus_45global from "/srv/app/app/middleware/airbus.global.ts";
import dbcembedded_45global from "/srv/app/app/middleware/dbcembedded.global.ts";
import language_45switch_45global from "/srv/app/app/middleware/languageSwitch.global.ts";
import tracking_45navigation_45global from "/srv/app/app/middleware/trackingNavigation.global.ts";
import tracking_45queries_45global from "/srv/app/app/middleware/trackingQueries.global.ts";
import manifest_45route_45rule from "/srv/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  airbus_45global,
  dbcembedded_45global,
  language_45switch_45global,
  tracking_45navigation_45global,
  tracking_45queries_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/srv/app/layers/self-service/middleware/auth.ts")
}